import Urls from '../urls.js';
import { fetch_status, fetch_json, fetch_error } from '../../../../scripts/utils/fetch.js';
import ModalView from '../../../../scripts/utils/modal-view.js';

export default class ProductInStockAppView extends ModalView {
	constructor({
		el,
		modal_selector,
		product,
		customer,
		navigation
	}) {
		super({ el, modal_selector, navigation });
		this.template_url = Urls.Templates.app;
		this.product = product;
		this.customer = customer;
		this.is_submit_success = false;
		this.site_settings = window.SiteSettings || {};
		this.opts = {
			product_name: product.name
		};
		this.render();
	}

	after_render() {
		this.once_rendered();
		this.initSelectors();
	}

	get_context() {
		let customerData = null;

		if (this.customer && !this.customer.guest) {
			customerData = {
				FirstName: this.customer.fname,
				LastName: this.customer.lname,
				EmailAddress: this.customer.emailaddress,
				PhoneNumber: this.customer.dtphone_body
			};
		}

		return {
			is_submit_success: this.is_submit_success,
			product: this.product,
			// customer: this.customer,
			navigation: this.navigation,
			customer: customerData
		};
	}

	initSelectors() {
		this.removeListeners();
		this.submit_btn = this.modal.querySelector('[type="submit"]');
		this.cancel_btn = this.modal.querySelector('.js-cancel');
		this.content = this.modal.querySelector('.modal-content');
		this.form = this.content.querySelector('form');
		this.fields = this.content.querySelectorAll('.form-control');
		this.addListeners();
	}

	addListeners () {
		this.submit_btn.addEventListener('click', this.submit.bind(this));
		this.cancel_btn.addEventListener('click', this.close.bind(this));

		this.fields.forEach(field => {
			['change', 'paste', 'keyup'].forEach(evt_name => {
				field.addEventListener(evt_name, this.change_event.bind(this));
			});
		});
	}

	removeListeners () {
		if (this.cancel_btn) {
			this.cancel_btn.removeEventListener('click', this.close.bind(this));
		}
		if (this.fields) {
			['change', 'keyup', 'paste'].forEach(evt_name => {
				this.fields.forEach(field => {
					field.removeEventListener(evt_name, this.change_event.bind(this));
				});
			});
		}
	}

	collectFormData() {
		const fd = new FormData(this.form);
		const data = {};

		for(let pair of fd.entries()) {
			const [ key ] = pair;
			data[key] = fd.getAll(key).length > 1 ? fd.getAll(key) : fd.get(key);
		}

		data.Products = [{
			ProductId: this.product.id,
			Quantity: data.qty
		}];
		delete data.qty;
		data.Source = 'Availability Check';

		return data;
	}

	getElementValue (selector) {
		const element = this.modal.querySelector(selector);
		if (element) {
			return element.value;
		}
		return null;
	}

	isEmail (value) {
		return /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i.test(value);
	}

	isUSZIP (value) {
		return /^\d{5}([ -]\d{4})?$/.test(value);
	}

	isPhone (value) {
		return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(value);
	}

	change_event (e) {
		if (this.is_valid()) {
			this.submit_btn.removeAttribute('disabled');
		} else {
			this.submit_btn.setAttribute('disabled', true);
		}
	}

	is_valid () {
		var valid = true;
		const data = this.collectFormData();

		for (const [k, v] of Object.entries(data)) {
			if (valid && !v.length) {
				valid = false;
			}
		}

		if (valid) {
			if (!this.isEmail(data.EmailAddress)) {
				valid = false;
			}
			if (!this.isUSZIP(data.ShipZipCode)) {
				valid = false;
			}
			if (!this.isPhone(data.PhoneNumber)) {
				valid = false;
			}
		}

		return valid;
	}

	submit () {
		if (this.site_settings.USE_RECAPTCHA_FOR_FORMS && this.site_settings.RECAPTCHA_SITE_KEY.length && grecaptcha) {
			grecaptcha.ready(function () {
				grecaptcha.execute(this.site_settings.RECAPTCHA_SITE_KEY, {action: 'submit'}).then(function (token) {
					this.submitRequest(token);
				}.bind(this));
			}.bind(this));
		} else {
			this.submitRequest();
		}
	}

	submitRequest (g_recaptcha_response) {
		const data = this.collectFormData();

		if (g_recaptcha_response) {
			data.g_recaptcha_response = g_recaptcha_response;
		}

		this.submit_btn.classList.add('progress');

		fetch( Urls.Api.form, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(data)
		})
			.then(fetch_status)
			.then(fetch_json)
			.then(() => {
				this.is_submit_success = true;
				this.render();
			})
			.catch(error => {
				fetch_error(error, true)
					.then(error_json => {
						let message = 'Something went wrong...';
						if (error_json && typeof error_json === 'object') {
							message = typeof error_json.responseJSON.Message === 'undefined' ? error_json.Message : error_json.responseJSON.Message;
						}
						this.content.innerHTML = `<p>${message}</p>`;
					});
			})
			.finally(() => {
				this.submit_btn.classList.remove('progress');
			});
	}

}
